var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags-input__wrapper"},_vm._l((_vm.dynamicTags),function(tag,index){return _c('el-tag',{key:tag + index,attrs:{"size":"small","username":_vm.userName,"type":_vm.tagType,"closable":true,"close-transition":false},on:{"close":function($event){return _vm.handleClose(tag)}}},[_vm._v("\n      "+_vm._s(tag)+"\n    ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }